import { callGetApiToServer } from "../callApi";

export async function getDeletedBatches(authtoken, skip, limit, city) {
  try {
    let header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Bearer " + authtoken,
    };

    let endUrl = `v1/auth/deleted-batches-list/${skip}/${limit}`;

    if (city) {
      endUrl += `?city=${city}`;
    }

    let responseData = await callGetApiToServer(header, "GET", endUrl);

    return responseData;
  } catch (err) {
    throw err;
  }
}
